import React, { useState, useEffect } from "react";
import { Card, CardBody, Button, CardTitle, Row } from "reactstrap";
import { listAllScheduledPaymentsbydate } from "../api/AutopayApi";
import { showApiError } from "../utils/errorRoutingUtils";
import {
	CurrencyDisplayElement,
	DateDisplayElement,
} from "../features/deal/components/DisplayElement";
import ReactTable from "../components/tables/ReactTable";
import { useFromUser } from "../stores/LocalStorageHelper";
import InputElement from "../features/forms/components/InputElement";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import * as yup from "yup";
import dayjs from "dayjs";
import { retrieveFailAlert } from "../utils/alertUtils";
import { acctStatusOptions } from "../constants/Constants";
const AllScheduledPayments = () => {
	const today = dayjs().format("YYYY-MM-DD");
	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");

	const [isLoading, setIsLoading] = useState(true);
	const [scheduledPayments, setScheduledPayments] = useState([]);
	const [fromDate, setFromDate] = useState(today);
	const [toDate, setToDate] = useState(today);
	const createSelectFilter = (options) => {
		return ({ column: { filterValue, setFilter } }) => (
			<div style={{ width: "100%" }}>
				<select
					value={filterValue ?? ""}
					onChange={(e) => setFilter(e.target.value || undefined)}
					style={{
						width: "100%", // Make dropdown fill the container
						padding: "4px 8px", // Optional: match table styling
						fontSize: "14px",
						boxSizing: "border-box",
					}}
				>
					<option value="">All</option>
					{options.map(({ value, label }) => (
						<option key={value} value={value}>
							{label}
						</option>
					))}
				</select>
			</div>
		);
	};

	const shortColumns = [
		{ Header: "#", accessor: (_r, idx) => idx + 1, style: { width: 20 } },
		{
			Header: "Due Date",
			accessor: "dueDate",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},
		{
			Header: "Receipt#",
			accessor: "transactionId",
			Cell: ({ value }) => {
				const str = value != null ? String(value) : "";
				// if it's shorter than 8, just show the whole thing
				return str.length > 8 ? str.slice(-10) : str;
			},
		},
		{
			Header: "Amount",
			accessor: "amount",
			Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
		},
		{
			Header: "Status",
			accessor: "code",
			Filter: createSelectFilter(acctStatusOptions),
			filter: "equals",
			Cell: ({ value }) =>
				acctStatusOptions.find((opt) => opt.value === value)?.label ??
				"Unknown",
		},
	];
	const handleSubmitList = () => {
		listAllScheduledPaymentsbydate(
			locationID,
			dayjs(fromDate).format("MM/DD/YYYY"),
			dayjs(toDate).format("MM/DD/YYYY")
		).then(
			(res) => {
				console.log(res);
				const payments = res.data.content.filter((item) => item.code !== 3);
				setScheduledPayments(payments);
				setIsLoading(false);
			},
			(err) => {
				if (!err.isGeneralError) {
					showApiError(err, retrieveFailAlert);
				}
			}
		);
	};
	// Define rules for each input field
	const schema = yup.object().shape({});

	// Define form validation parameters
	const methods = useForm({
		reValidateMode: "onBlur",
		resolver: yupResolver(schema),
	});
	useEffect(() => {
		console.log(fromDate);
		console.log(toDate);
		console.log(locationID);
		if (isLoading) {
			handleSubmitList();
		}

		// eslint-disable-next-line
	}, [isLoading]);

	return (
		<div className="row d-flex justify-content-center">
			<div className="col-md-8 px-0 content  justify-content-center align-items-center">
				<Card className="mt-3">
					<CardTitle tag="h3">
						Scheduled Payments
						<Row className="justify-content-center">
							<InputElement
								{...methods}
								disableValidation
								value={fromDate}
								onChange={(e) => setFromDate(e.target.value)}
								name="fromDate"
								label="From Date"
								type="date"
							/>
							<InputElement
								{...methods}
								disableValidation
								value={toDate}
								onChange={(e) => setToDate(e.target.value)}
								name="toDate"
								label="To Date"
								type="date"
							/>
							<div>
								<div>   </div>
								<Button
									className="mr-1"
									color="primary"
									onClick={() => {
										handleSubmitList();
									}}
									size="sm"
								>
									Update List
								</Button>
							</div>
						</Row>
					</CardTitle>

					<CardBody>
						<ReactTable data={scheduledPayments} columns={shortColumns} />
					</CardBody>
				</Card>
			</div>
		</div>
	);
};
export default AllScheduledPayments;
